export interface LoggerInterface {
  log: (...data: LogData[] | LoggerInterface[]) => void;
  info: (...data: LogData[] | LoggerInterface[]) => void;
  warn: (...data: LogData[] | LoggerInterface[]) => void;
  error: (...data: LogData[] | LoggerInterface[]) => void;
  debug: (...data: LogData[] | LoggerInterface[]) => void;
}

export const LogLevels = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

export interface LoggerServiceInterface extends LoggerInterface {
  setLoggers: (...data: LoggerInterface[]) => void;
  setLogContext: (loggerData: LoggerData) => void;
}

export type LoggerData = {
  /**
   * @description Name of the component adding the log.
   */
  component: string;
  /**
   * @description Name of the platform / MicroFrontend adding the log.
   */
  product: string;
  /***
   * @description Page Name adding this log.
   * Marked as optional for Pods
   */
  page?: string;
  sessionId?: string;
};

declare global {
  // eslint-disable-next-line
  var loggerService: LoggerServiceInterface;
  interface Window {
    loggerService: LoggerServiceInterface;
  }
}

export type LogData = string | number | boolean | object | unknown;
